import { useEffect, useState } from "react";
import { PartyPopper, X } from "lucide-react";
import { api } from "../../lib/api";

// Sound Request Alerts: a small dismissible banner at the top of the parent
// dashboard the moment a requested speech sound's video model arrives.
export const SoundReadyBanner = () => {
  const [ready, setReady] = useState([]);

  useEffect(() => {
    api.get("/sound-requests")
      .then(({ data }) =>
        setReady((data.requests || []).filter((r) => r.status === "ready" && !r.seen_at)))
      .catch(() => {});
  }, []);

  if (!ready.length) return null;

  const dismiss = () => {
    ready.forEach((r) => api.post(`/sound-requests/${r.request_id}/seen`).catch(() => {}));
    setReady([]);
  };

  const names = ready.map((r) => `'${r.sound}'`).join(", ");
  return (
    <div
      className="flex items-center gap-3 rounded-xl border-2 border-emerald-300 bg-emerald-50 px-4 py-3"
      role="status"
      data-testid="sound-ready-banner"
    >
      <PartyPopper className="h-5 w-5 text-emerald-600 shrink-0" aria-hidden="true" />
      <p className="text-sm font-semibold text-emerald-900 flex-1">
        The {names} sound {ready.length > 1 ? "videos you asked for are" : "video you asked for is"} ready —
        it's live in the practice menu right now!
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="text-emerald-700 hover:text-emerald-900 p-1"
        aria-label="Dismiss sound ready alert"
        data-testid="sound-ready-dismiss"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
};
